module.exports = __webpack_public_path__ + "static/media/Strain.fdc407ed.svg";